<template>
  <v-dialog v-model="dialog" max-width="600" @keydown.esc="cancel">
    <v-card>
      <v-card-title>
        <h4>プラスの氣を送る</h4>
        <v-spacer />
        <IconButton icon="mdi-close" @click="cancel_comment" />
      </v-card-title>

      <v-card-text>
        <div class="row mx-auto">
          <div class="col-12" align="center">
            <Avatar :src="this.toUserAvater" :size="130" />
          </div>
          <div class="col-12">
            <h3 class="text-center mt-0">
              {{ this.toUserName }}<small>({{ this.toUserPosition }})</small>
            </h3>
          </div>
        </div>

        <v-textarea
          v-model="sendComment"
          clearable
          clear-icon="cancel"
          :label="messageEntryWord"
        ></v-textarea>

        <div align="center">
          <Button @click="openConfirmDialog" color="primary">送る</Button>
        </div>
      </v-card-text>

      <Loader :loading="loading" />

      <DialogMessage ref="dialog" />

      <ConfirmDialog
        ref="confirm"
        :title="messegeDialogWord"
        :message="confirmMessage"
        buttonMessage="OK"
        @confirm="send_comment"
      >
      </ConfirmDialog>
    </v-card>
  </v-dialog>
</template>
<script>
import axios from 'axios';
import config from '../../../const.js';
import message from '../../../message.js';
import moment from 'moment';
import ConfirmDialog from '@/components/Common/ConfirmMessage.vue';
import { getSessionStorageItem, isEmoji } from '../../../common.js';
export default {
  components: {
    ConfirmDialog,
  },
  data: () => ({
    dialog: false,
    confirm: false,
    resolve: null,
    reject: null,
    loading: false,

    organaizationKey: null,
    toUserId: null,
    toUserName: null,
    toUserNameFurigana: null,
    toUserPosition: null,
    toUserAvater: null,
    toStartWorkingAt: null,
    sendComment: null,
    confirmMessage: null,
    replyFlg: config.FLG_OFF,
    messegeDialogWord: null,
    messageEntryWord: null,

    options: {
      color: 'primary',
      width: 300,
    },
  }),
  created() {
    // コメント欄初期化
    this.comment = config.PURASUNOKI_INIT_COMMENT;
  },
  methods: {
    open(
      organaizationKey,
      toUserId,
      toUserName,
      toUserNameFurigana,
      toUserPosition,
      toUserAvater,
      toStartWorkingAt,
      replyFlg,
      options
    ) {
      this.dialog = true;
      this.confirm = false;

      this.organaizationKey = organaizationKey;
      this.toUserId = toUserId;
      this.toUserName = toUserName;
      this.toUserNameFurigana = toUserNameFurigana;
      this.toUserPosition = toUserPosition;
      this.toUserAvater = toUserAvater;
      this.toStartWorkingAt = toStartWorkingAt;
      this.replyFlg = replyFlg;

      if (this.replyFlg == config.REPLY_FLG_ON) {
        this.messegeDialogWord = config.REPLY_MESSAGE_WORD + '送信';
        this.messageEntryWord =
          config.REPLY_MESSAGE_WORD + 'を入力してください。';
      } else {
        this.messegeDialogWord = config.PURASUNOKI_MESSAGE_WORD + '送信';
        this.messageEntryWord =
          config.PURASUNOKI_MESSAGE_WORD + 'を入力してください。';
      }

      this.sendComment = '';
      this.options = Object.assign(this.options, options);

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    openConfirmDialog() {
      // 入力チェック
      if (this.sendComment == null || !this.sendComment.trim()) {
        this.$refs.dialog.open('info', message.MSG_INFO_PURASUNOKI_ENPTY);
        return;
      }
      // プラスの氣文字数チェック
      let userInfo = getSessionStorageItem();
      let commentMinString = Number(userInfo.COMMENT_MIN_STRING);
      if (commentMinString > 0) {
        // プラスの氣入力最小文字数が[0]以上の場合にチェック
        let sendCommentLegnth = this.sendComment.length;
        if (sendCommentLegnth < commentMinString) {
          let infoStr = message.MSG_INFO_PURASUNOKI_MIN_STRING;
          let infoStrReplace = infoStr.replace(/a/g, commentMinString);
          this.$refs.dialog.open('info', infoStrReplace);
          return;
        }
      }
      // プラスの氣絵文字チェック
      if (isEmoji(this.sendComment)) {
        let infoStr = message.MSG_INFO_PURASUNOKI_EMOJI_STRING;
        this.$refs.dialog.open('info', infoStr);
        return;
      }
      // システム管理者の権限チェック
      if (userInfo.USER_RANK == config.USER_RANK_SYSOP) {
        // システム管理者はプラスの氣を送信できない
        let infoStr = 'システム管理者はプラスの氣を送信できません。';
        this.$refs.dialog.open('info', infoStr);
        return;
      }

      // 確認ダイアログ表示
      if (this.replyFlg == config.REPLY_FLG_ON) {
        this.confirmMessage =
          this.toUserName + 'さんに返信メッセージを送りますか？';
      } else {
        this.confirmMessage =
          this.toUserName + 'さんにプラスの氣を送りますか？';
      }
      this.$refs.confirm.open();
    },
    cancel_comment() {
      if (this.confirm) {
        this.confirm = false;
      } else {
        this.resolve(false);
        this.dialog = false;
      }
    },
    send_comment() {
      // ローディング画像表示
      this.loading = true;
      //ユーザ情報の取得
      let userInfo = getSessionStorageItem();

      // コメント改行コード置き換え
      this.sendComment.replace('\n', '\\n');

      // プラスの氣情報作成
      let sendTime = moment().format('YYYYMMDDHHmmss');
      let sendKey = userInfo.USER_ID + sendTime;
      let toUserAvater = this.toUserAvater.replace(
        config.S3_END_POINT + config.AVATER_DIRECTORY,
        ''
      );
      let showTitle =
        "<span class='text--primary'>" +
        userInfo.USER_NAME +
        '</span> &mdash; ' +
        moment().format('YYYY/MM/DD HH:mm:ss');
      let showSubTitle =
        "<span class='text--primary'>to " +
        this.toUserName +
        '</span> &mdash; ' +
        this.sendComment;

      //----- プラスの氣送信リクエストPOST
      axios
        .post(config.CONNECT_URL + '/Encouragements/comment', {
          SESSION_ID: userInfo.SESSION_ID,
          SEND_KEY: sendKey,
          SEND_TIME: sendTime,
          ORGANIZATION_KEY: this.organaizationKey,
          SEND_USER_ID: userInfo.USER_ID,
          SEND_USER_NAME: userInfo.USER_NAME,
          SEND_USER_NAME_FURIGANA: userInfo.USER_NAME_FURIGANA,
          SEND_USER_POSITION: userInfo.POSITION_NAME,
          SEND_USER_AVATER: userInfo.USER_AVATER,
          SEND_START_WORKING_AT: userInfo.START_WORKING_AT,
          SEND_USER_DEPARTMENT_KEY: config.EMPTY_STRING, // 部署キー
          SEND_USER_DEPARTMENT_NAME: config.EMPTY_STRING, // 部署名
          TO_USER_ID: this.toUserId,
          TO_USER_NAME: this.toUserName,
          TO_USER_NAME_FURIGANA: this.toUserNameFurigana,
          TO_USER_POSITION: this.toUserPosition,
          TO_USER_AVATER: toUserAvater,
          TO_START_WORKING_AT: this.toStartWorkingAt,
          TO_USER_DEPARTMENT_KEY: config.EMPTY_STRING, // 部署キー
          TO_USER_DEPARTMENT_NAME: config.EMPTY_STRING, // 部署名
          SEND_COMMENT: this.sendComment,
          NICE_COUNT: 0,
          REPLY_FLG: this.replyFlg, // 返信フラグ
          SHOW_TITLE: showTitle,
          SHOW_SUBTITLE: showSubTitle,
          SHOW_SEND_TIME: moment().format('YYYY/MM/DD HH:mm:ss'),
        })
        .then((response) => {
          // ローディング画像終了
          this.loading = false;

          let msgStr = '';
          if (response.status == 200) {
            if (this.replyFlg == config.REPLY_FLG_ON) {
              msgStr =
                this.toUserName + message.MSG_INFO_SEND_REPLY_MESSAGE_COMPLETE;
            } else {
              msgStr =
                this.toUserName + message.MSG_INFO_SEND_PURASUNOKI_COMPLETE;
            }
            this.$refs.dialog.open('info', msgStr);
          }
        })
        .catch((error) => {
          // ローディング画像終了
          this.loading = false;

          let errStr = '';
          if (error.response.status == 400) {
            errStr = message.MSG_ERROR_SESSION_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          }
        });

      this.resolve(true);
      this.dialog = false;
    },
    agree() {
      this.resolve(true);
      this.dialog = false;
    },
    cancel() {
      this.resolve(false);
      this.dialog = false;
    },
  },
};
</script>

<style scoped>
.v-card:not(.v-sheet--tile):not(.v-card--shaped) {
  border-radius: 0.5rem;
  border-top: 5px solid #e55513;
}
</style>
